import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { MessageSquareIcon, PenToolIcon, CodeIcon, RocketIcon } from 'lucide-react';
export function ProcessSection() {
  const revealRef = useScrollReveal();
  const steps = [{
    num: '01',
    title: 'Konzultácia',
    desc: 'Pochopíme váš biznis a identifikujeme príležitosti pre AI.',
    icon: <MessageSquareIcon className="w-6 h-6" data-id="element-524" data-mp="1mql7b0pskiej" />,
    color: 'text-blue-500',
    bg: 'bg-blue-50',
    glow: 'shadow-blue-100'
  }, {
    num: '02',
    title: 'Návrh',
    desc: 'Navrhneme architektúru a UX pre maximálnu konverziu.',
    icon: <PenToolIcon className="w-6 h-6" data-id="element-525" data-mp="1cz74aiymt0gn" />,
    color: 'text-purple-500',
    bg: 'bg-purple-50',
    glow: 'shadow-purple-100'
  }, {
    num: '03',
    title: 'Vývoj',
    desc: 'V 14-dňových šprintoch dodávame reálne fungujúce časti.',
    icon: <CodeIcon className="w-6 h-6" data-id="element-526" data-mp="20pugvhjhse9j" />,
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    glow: 'shadow-emerald-100'
  }, {
    num: '04',
    title: 'Launch',
    desc: 'Nasadenie, testovanie a škálovanie vašej novej PWA.',
    icon: <RocketIcon className="w-6 h-6" data-id="element-527" data-mp="2b3k6rowl1ou2" />,
    color: 'text-amber-500',
    bg: 'bg-amber-50',
    glow: 'shadow-amber-100'
  }];
  return <section ref={revealRef} className="py-36 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-528" data-mp="21awbwzp5xuxz">
      <div className="reveal text-center mb-28" data-id="element-529" data-mp="1nabp7sg4nez7">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-6" data-id="element-530" data-mp="1rd8dnzscm5b2">
          NÁŠ PROCES
        </p>
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-6" data-id="element-531" data-mp="1deqtgc1njaxw">
          Ako Spolupracujeme
        </h2>
        <p className="text-xl text-apple-gray font-light max-w-2xl mx-auto leading-relaxed" data-id="element-532" data-mp="1iewcx4xrpr4w">
          Náš proces je navrhnutý pre rýchlosť a kvalitu. Od prvého stretnutia
          po nasadenie do produkcie.
        </p>
      </div>

      <div className="relative" data-id="element-533" data-mp="3b9e6cf9tvtl3">
        {/* Connecting Line (Desktop) — gradient */}
        <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-blue-200 via-purple-200 via-emerald-200 to-amber-200 z-0 rounded-full" data-id="element-534" data-mp="36akoybrf7ifn" />
        {/* Connecting Line (Mobile) */}
        <div className="md:hidden absolute top-0 bottom-0 left-8 w-[2px] bg-gradient-to-b from-blue-200 via-purple-200 via-emerald-200 to-amber-200 z-0 rounded-full" data-id="element-535" data-mp="2wcwrvf6cdyub" />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative z-10" data-id="element-536" data-mp="3u1zvkgq8clwp">
          {steps.map((step, index) => <div key={index} className={`reveal reveal-delay-${index + 1} flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-0`} data-id="element-537" data-mp="3k9u89kaxasnu" data-mpi={index}>
              <div className={`flex-shrink-0 w-16 h-16 ${step.bg} rounded-full shadow-lg ${step.glow} flex items-center justify-center md:mb-8 relative z-10 border border-white/80`} data-id="element-538" data-mp="gkza0al54pco">
                <div className={step.color} data-id="element-539" data-mp="k3yder5utxmv">{step.icon}</div>
              </div>
              <div className="flex flex-col md:items-center md:text-center pt-2 md:pt-0" data-id="element-540" data-mp="o4i71kr7yj49">
                <span className={`text-xs font-bold ${step.color} mb-2 tracking-[0.2em]`} data-id="element-541" data-mp="t3uv28tttw8f">
                  {step.num}
                </span>
                <h3 className="text-xl font-bold text-apple-black mb-3" data-id="element-542" data-mp="y0v14jqoeyzj">
                  {step.title}
                </h3>
                <p className="text-apple-gray font-light leading-relaxed text-sm" data-id="element-543" data-mp="173e0uuz60vhk">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}